"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAnimations = void 0;
var utilities_1 = require("./utilities");
var animationCache = {};
var language = (0, utilities_1.getLanguage)();
function loadAnimation(filename) {
    var cacheKey = "".concat(filename, "-").concat(language);
    if (animationCache[cacheKey]) {
        return Promise.resolve(animationCache[cacheKey]);
    }
    return new Promise(function (resolve) {
        var script = document.createElement("script");
        script.src = "../animate/".concat(language, "/").concat(filename, ".js");
        script.onload = function () {
            return setTimeout(function () {
                var animation = require(filename).default;
                var library = animation.composition.getLibrary();
                var manifest = library.properties.manifest;
                manifest.forEach(function (asset) {
                    if (!asset.src.startsWith("http")) {
                        asset.src = "../animate/".concat(language, "/").concat(asset.src);
                    }
                });
                animationCache[filename] = animation;
                resolve(animation);
            });
        };
        document.head.appendChild(script);
    });
}
function loadAnimations(timeline) {
    var promises = timeline.map(function (section) { return loadAnimation(section); });
    return Promise.all(promises);
}
exports.loadAnimations = loadAnimations;
//# sourceMappingURL=module.js.map